import { ITaskType } from "./types";

export const defaultTaskTypes: ITaskType[] = [
	{ id: "task", label: "Task" },
	{ id: "summary", label: "Summary task" },
	{ id: "milestone", label: "Milestone" },
];
